/*
 * Copyright (c) 2023 Shabélab inc.
 * All Rights Reserved.
 * 
 * This software is the property of Shabélab inc.
 * 
 * This software is supplied "AS IS" without any warranties and support.
 * 
 * Distribution, reproduction, and modification of this software or 
 * any derivative works are forbidden without written permission from 
 * Shabélab inc.
 */

import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { SocketContext, socket, initSocket } from '../context/socket';
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFlask,
  faArrowCircleDown,
  faLongArrowAltDown,
  faArrowRight,
  faArrowLeft,
  faDizzy,
  faFrown,
  faSmile,
  faLaughBeam,
  faGrinSquintTears,
  faPlusCircle,
  faTrash,
  faCommentDots,
  faSpellCheck,
  faBroadcastTower,
  faPlay,
  faPause,
  faPlayCircle,
  faSave,
  faToggleOn,
  faToggleOff,
  faSearch,
  faSync,
  faLemon,
  faLongArrowAltUp,
  faStar,
  faSquare,
  faCheckSquare,
  faList,
  faExclamationCircle,
  faCopy,
  faExpand,
  faCompress,
  faThumbsUp,
  faThumbsDown,
  faChevronDown,
  faChevronUp,
  faArrowDown,
  faHandPointer,
} from '@fortawesome/free-solid-svg-icons'
import 'react-tooltip/dist/react-tooltip.css'

const ConnectStart = lazy(() => import('./pages/ConnectStart'));
const ReconstructChat12 = lazy(() => import('./pages/ReconstructChat12'));
const RealtimeViewV2 = lazy(() => import('./pages/RealtimeViewV2'));
const AudioList = lazy(() => import('./pages/AudioList'));
// const TestView = lazy(() => import('./pages/TestView'));
const RealtimeViewParent = lazy(() => import('./pages/RealtimeViewParent'));

library.add(faFlask, faArrowCircleDown, faLongArrowAltDown, faArrowRight, faArrowLeft,
faDizzy, faFrown, faSmile, faLaughBeam, faGrinSquintTears, faPlusCircle, faTrash,
faCommentDots, faSpellCheck, faBroadcastTower, faPlay, faPause, faPlayCircle, faSave,
faToggleOn, faToggleOff, faSearch, faSync, faLemon, faLongArrowAltUp, faStar,
faSquare, faCheckSquare, faList, faExclamationCircle, faCopy, faExpand, faCompress,
faThumbsUp, faThumbsDown, faChevronDown, faChevronUp, faArrowDown, faHandPointer)

const Loading = () => {
  return (
    <p style={{
      color: '#555555',
    }}>
      ロード中…
    </p>
  )
}

const App = (props) => {

  return (
    <div className="App">

      <Suspense fallback={<Loading />}>

        <SocketContext.Provider value={{
          'socket': socket,
          'initSocket': initSocket,
        }}>

          <Routes>
            <Route path="/" element={<RealtimeViewV2 />}></Route>
            <Route path="/index.html" element={<RealtimeViewV2 />}></Route>
            <Route path="/settings.html" element={<ConnectStart />}></Route>
            <Route path="/realtime_v2.html" element={<RealtimeViewV2 />}></Route>
            <Route path="/reconstruct.html" element={<ReconstructChat12 />}></Route>
            <Route path="/audio_list.html" element={<AudioList />}></Route>
            <Route path="/realtime_parent.html" element={<RealtimeViewParent />}></Route>
          </Routes>

        </SocketContext.Provider>

      </Suspense>
    </div>
  )
}

export default App
